const MONGO_ID = /^[a-f0-9]{24}$/i
const SHORT_CODE = /^[A-Z0-9]{6}$/i

function fromObject(value) {
  if (!value || typeof value !== 'object') return ''
  return (
    value.iTicketId ||
    value.iOrderId ||
    value.sTicketId ||
    value.sCode ||
    value.code ||
    value.ticketId ||
    value.ticket ||
    ''
  )
}

export function parseScanValue(raw) {
  if (raw == null) return null
  if (typeof raw === 'object') return parseScanValue(fromObject(raw))

  const text = String(raw).trim()
  if (!text) return null

  if (text.startsWith('{') || text.startsWith('[')) {
    try {
      return parseScanValue(JSON.parse(text))
    } catch {
      // not JSON
    }
  }

  try {
    const url = new URL(text)
    const fromQuery =
      url.searchParams.get('iTicketId') ||
      url.searchParams.get('iOrderId') ||
      url.searchParams.get('code') ||
      url.searchParams.get('ticket') ||
      url.searchParams.get('ticketId')
    if (fromQuery) return parseScanValue(fromQuery)
    const last = url.pathname.split('/').filter(Boolean).pop()
    if (last) return parseScanValue(last)
  } catch {
    // not a URL
  }

  const cleaned = text.replace(/[^a-zA-Z0-9]/g, '')
  if (MONGO_ID.test(cleaned)) return { type: 'mongo', value: cleaned.toLowerCase() }
  if (SHORT_CODE.test(cleaned)) return { type: 'short', value: cleaned.toUpperCase() }

  const shortMatch = cleaned.toUpperCase().match(/[A-Z0-9]{6}/)
  if (shortMatch) return { type: 'short', value: shortMatch[0] }

  return { type: 'short', value: text.toUpperCase() }
}

export function displayTicketCode(raw) {
  const parsed = parseScanValue(raw)
  return parsed?.value || String(raw || '').trim().toUpperCase()
}
